import axiosInstance from '@/lib/axios';

export interface Contract {
  id: string;
  _id?: string;
  title: string;
  client: string;
  value: number;
  status: 'Active' | 'Pending' | 'Expired';
  startDate: string;
  endDate: string;
  type: string;
  renewalDate: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface ContractFormData {
  title: string;
  client: string;
  value: number;
  status: 'Active' | 'Pending' | 'Expired';
  startDate: string;
  endDate: string;
  type: string;
  renewalDate: string;
}

export interface ContractListResponse {
  data: Contract[];
  total: number;
  page: number;
  limit: number;
  hasMore: boolean;
}

export interface ContractStats {
  activeContracts: number;
  totalValue: number;
  expiringSoon: number;
  pendingRenewals: number;
}

export interface ContractFilters {
  page?: number;
  limit?: number;
  search?: string;
  status?: string;
  client?: string;
  type?: string;
  sort?: string;
  order?: 'asc' | 'desc';
}

export async function getContracts(filters: ContractFilters = {}): Promise<ContractListResponse> {
  const params = new URLSearchParams();
  
  if (filters.page) params.append('page', filters.page.toString());
  if (filters.limit) params.append('limit', filters.limit.toString());
  if (filters.search) params.append('search', filters.search);
  if (filters.status) params.append('status', filters.status);
  if (filters.client) params.append('client', filters.client);
  if (filters.type) params.append('type', filters.type);
  if (filters.sort) params.append('sort', filters.sort);
  if (filters.order) params.append('order', filters.order);

  const response = await axiosInstance.get(`/contracts?${params.toString()}`);
  return response.data;
}

export async function getContractById(id: string): Promise<Contract> {
  const response = await axiosInstance.get(`/contracts/${id}`);
  return response.data;
}

export async function createContract(contractData: ContractFormData): Promise<Contract> {
  const response = await axiosInstance.post('/contracts', contractData);
  return response.data;
}

export async function updateContract(id: string, contractData: Partial<ContractFormData>): Promise<Contract> {
  const response = await axiosInstance.patch(`/contracts/${id}`, contractData);
  return response.data;
}

export async function deleteContract(id: string): Promise<{ message: string; deleted: Contract }> {
  const response = await axiosInstance.delete(`/contracts/${id}`);
  return response.data;
}

export async function getContractStats(): Promise<ContractStats> {
  const response = await axiosInstance.get('/contracts/stats');
  return response.data;
}

export const contractService = {
  getContracts,
  getContractById,
  createContract,
  updateContract,
  deleteContract,
  getContractStats,
};